import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';

// Initialize Swiper modules
Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);
window.Swiper = Swiper;

// Lazyload
import lazySizes from 'lazysizes';

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// fslightbox
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";


// LightGallery
// import lightGallery from 'lightgallery';
// import lgThumbnail from 'lightgallery/plugins/thumbnail';
// import lgZoom from 'lightgallery/plugins/zoom';
// import 'lightgallery/css/lightgallery-bundle.css';
//
// lightGallery(document.getElementById('products-light-gallery'), {
//     plugins: [lgThumbnail,lgZoom],
//     thumbnail:true,
//     speed: 500,
// });
//
// lightGallery(document.getElementById('gallery-light-gallery'), {
//     plugins: [lgThumbnail,lgZoom],
//     thumbnail:true,
//     speed: 500,
// });

const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    const workshopsSwiper = new Swiper('.workshops-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1,
        modules: [Navigation, Pagination],
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            bulletClass: 'swiper-pagination-bullet',
            clickable: true,
        },
        clickable: "true",
        breakpoints: {
            768: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 1,
            },
        }

    })

    const booksSwiper = new Swiper('.books-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.2,
        freeMode: true,
        clickable: "true",
        slidesOffsetAfter: 120,
        modules: [Navigation, Pagination],
        breakpoints: {
            768: {
                slidesPerView: 2.2,
            },
            1024: {
                slidesPerView: 2.7,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
            1280: {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }, slidesPerView: 4,
                spaceBetween: 25,

            },
        }

    })

    const blogSwiper = new Swiper('.blog-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.1,
        spaceBetween: 20,
        freeMode: true,
        observer: true,
        clickable: "true",
        slidesOffsetAfter: 120,
        modules: [Navigation, Pagination],
        breakpoints: {
            768: {
                slidesPerView: 2.2,
            },
            1024: {
                slidesPerView: 2.9,
                navigation: {
                    nextEl: '.blog-swiper-button-next',
                    prevEl: '.blog-swiper-button-prev',
                    disabledClass: 'text-gray-400',
                },
            },
            1280: {
                slidesPerView: 4,
                centeredSlides: true,
                centeredSlidesBounds: true,
                navigation: {
                    nextEl: '.blog-swiper-button-next',
                    prevEl: '.blog-swiper-button-prev',
                    disabledClass: 'text-gray-400',
                },
            },
        }

    })

    const gallerySwiper = new Swiper('.gallery-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.1,
        spaceBetween: 20,
        freeMode: true,
        clickable: "true",
        slidesOffsetAfter: 120,
        modules: [Navigation, Pagination],
        breakpoints: {
            768: {
                slidesPerView: 2.2,
            },
            1024: {
                navigation: {
                    nextEl: '.gallery-swiper-button-next',
                    prevEl: '.gallery-swiper-button-prev',
                    disabledClass: 'text-gray-400',
                },
                slidesPerView: 2.8,
            },
            1280: {
                navigation: {
                    nextEl: '.gallery-swiper-button-next',
                    prevEl: '.gallery-swiper-button-prev',
                    disabledClass: 'text-gray-400',
                },
                slidesPerView: 4,
            },
        }

    })

    const productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    const productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    let productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });

};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

// window.addEventListener("livewire:navigated", function(){
//     window.scrollTo({top: 0, behavior: 'smooth'});
// })

// console.clear();
